import { rawAbcDataActionTypes } from '../constants/ApiConstants';

const initialState = {
  rawABCDataList: null, 
  delete_rawABCData: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {    
  case rawAbcDataActionTypes.get_rawABCDataList.REQUEST:
    return {
      ...state,
      loading: true,
      rawABCDataList: null,
    };
  case rawAbcDataActionTypes.get_rawABCDataList.SUCCESS:
    return {
      ...state,
      loading: false,
      rawABCDataList: payload,
    };
  
  case rawAbcDataActionTypes.delete_rawABCData.REQUEST:
    return {
      ...state,
      loading: true,
      delete_rawABCData: null,
    };
  case rawAbcDataActionTypes.delete_rawABCData.SUCCESS:
    return {
      ...state,
      loading: false,
      delete_rawABCData: payload,
    };
  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/BehaviorReductiom/RawABCData/reducers/rawABCDataReducer.js